import React from 'react';
import styled from 'styled-components';

import { useTranslation, Trans } from '@lt/localization';

import { Link, Bubble } from '@lt/components';
import { QuestionCircle } from '@lt/components/icons-react';

import {
  EXTRA_INSURANCE_FULL_DETAILS_LINK,
  EXTRA_INSURANCE_CONDITIONS_LINK,
} from './constants';

import type { PropsFromRedux } from '../../index';

export const InsuranceDescription = (
  props: Pick<PropsFromRedux, 'searchType'>,
): JSX.Element => {
  const { searchType } = props;

  const { t } = useTranslation();
  return (
    <>
      <span>
        {t('checkout.services.insuranceDescription', {
          context: searchType,
        })}
      </span>
      <StyledBubble
        placement="left"
        text={t('checkout.services.insuranceTooltip', {
          context: searchType,
        })}
      >
        <StyledQuestionCircle />
      </StyledBubble>
      <Link href={EXTRA_INSURANCE_FULL_DETAILS_LINK}>
        {t('checkout.services.fullDetails')}
      </Link>

      <WarningText>
        <Trans
          i18nKey="checkout.services.insuranceWarning"
          components={{
            Link: <Link href={EXTRA_INSURANCE_CONDITIONS_LINK} />,
          }}
        />
      </WarningText>
    </>
  );
};

const WarningText = styled.span`
  margin-top: 5px;
  display: block;
`;

const StyledQuestionCircle = styled(QuestionCircle)`
  height: 16px;
  width: 16px;
  stroke: #919499;
  translate: 0px 3px;
`;

const StyledBubble = styled(Bubble)`
  display: inline-flex;
`;
